<template>
    <a-pagination
      size="small"
      :total="total"
      :showTotal="total=>`${totalText + total}`"
      :itemRender="itemRender"
      :hideOnSinglePage="true"
      @change="handlePageNumChange"
      @showSizeChange="handleShowSizeChange"
    ></a-pagination>
</template>

<script lang="jsx">
  export default {
    name: 'index.vue',
    props:{
      total:{
        type:Number,
        default:10,
      }
    },
    computed:{
      totalText(){
        return this.$t('pagination.total');
      },
      // nextText(){
      //   return this.$t('pagination.next');
      // }
    },
    methods:{
      itemRender(current, type, originalElement) {
        if (type === 'prev') {
          return false;
        } else if (type === 'next') {
          return <a>next</a>;
        }
        return originalElement;
      },
      handlePageNumChange(){

      },
      handleShowSizeChange(){

      }
    }
  }
</script>

<style scoped>
  .ant-pagination{
    float: right;
  }
</style>
